import React from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Form,
  Input,
  Image
} from '@lockerpm/design';

import stripeComponents from "../stripe";

import StripeLogoImg from "../../assets/images/logos/stripe.svg"

import global from "../../config/global";

const PaymentMethods = (props) => {
  const {
    CardNumberInput,
    CardExpiryInput,
    CardCvcInput
  } = stripeComponents;
  const {
    className = '',
  } = props;
  const { t } = useTranslation();

  return (
    <div className={`payment-methods ${className}`}>
      <p className="font-semibold text-[16px] mb-1">
        {t('billing.payment_method')}
      </p>
      <p className="mb-2">
        {t('billing.intro')}
      </p>
      <Row gutter={[24, 0]}>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="name"
            label={<p className="font-semibold">
              {t('common.cardholder')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.cardholder')),
            ]}
          >
            <Input
              placeholder={t('placeholder.cardholder')}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            className="mb-0"
            label={<p className="font-semibold">
              <span className="text-danger">*</span> {t('common.card_number')}
            </p>}
          >
            <CardNumberInput />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            className="mb-0"
            label={<p className="font-semibold">
              <span className="text-danger">*</span> {t('common.expiration')}
            </p>}
          >
            <CardExpiryInput />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            className="mb-0"
            label={<p className="font-semibold">
              <span className="text-danger">*</span> {t('common.cvc')}
            </p>}
          >
            <CardCvcInput />
          </Form.Item>
        </Col>
      </Row>
      <div className="form-group col-span-2 mt-4">
        <Image
          src={StripeLogoImg}
          alt="Stripe"
          height={30}
          preview={false}
        />
        <p className="mt-3">
          <Trans
            i18nKey={'billing.stripe_desc'}
            components={{
              a: <a className='kt-link' href='https://stripe.com/' rel='noopener' target='_blank'/>
            }}
          />
        </p>
      </div>
    </div>
  );
}

export default PaymentMethods;